import axiosInstance from "../axiosInstance";


export const checkDashboard = async () => {
  const response = await axiosInstance.post('/customers/stats', {});
  return response.data;
};
export const checkCustomers = async (page) => {
    const response = await axiosInstance.post('/customers', {page});
    return response.data;
  };
  export const getNfts = async (page) => {
    const response = await axiosInstance.post('/nfts', {page});
    return response.data;
  };
  export const getNft = async (id) => {
    const response = await axiosInstance.post('/nft', {id});
    return response.data;
  };

  export const createNft = async (formData) => {
    const response = await axiosInstance.post('/nfts/add', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  };
  
  export const updateNft = async (formData) => {
    const response = await axiosInstance.post('/nfts/update', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  };
  //Home
  export const getHomes = (page = 1) => {
    return axiosInstance.get(`/home-sections?page=${page}`);
  };
  
  export const getHome = (id) => {
    return axiosInstance.get(`/home-sections/${id}`);
  };
  
  export const createHome = (data) => {
    return axiosInstance.post(`/home-sections`, data, {
      headers: { 
        'Content-Type': 'multipart/form-data',
      }
    });
  };
  
  export const updateHome = (id, data) => {
    // استفاده از POST با _method=PUT برای پشتیبانی از آپلود فایل
    return axiosInstance.post(`/home-sections/update/${id}`, data, {
      headers: { 
        'Content-Type': 'multipart/form-data',
      }
    });
  };
  
  export const deleteHome = (id) => {
    return axiosInstance.post(`/home-sections/${id}`);
  };
  
  export const getPublicHomeSections = () => {
    return axiosInstance.get('/api/home-sections');
  };

  export const changePassword = async (new_password,current_password) => {
    const response = await axiosInstance.post('/change-password', {new_password,current_password});
    return response.data;
  };